module.exports = __webpack_public_path__ + "img/huishou-h.719f26cf.svg";